import { render, staticRenderFns } from "./InternalFixtures.vue?vue&type=template&id=19f96dde&"
import script from "./InternalFixtures.vue?vue&type=script&lang=ts&"
export * from "./InternalFixtures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports